"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _sortableTableHeader = _interopRequireDefault(require("../../../../core/sortable-table-header"));
var _entriesTable = _interopRequireDefault(require("../entries-table"));
var _cancelEntry = _interopRequireDefault(require("../entry-action-buttons/cancel-entry"));
var _waitingListManagement = _interopRequireDefault(require("../entry-action-buttons/waiting-list-management"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("th", {
  key: "buttons"
});
class PostalEntriesTable extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_renderExtraColumnHeadings", ({
      sortedColumnID,
      sortedDirection,
      onToggleSort
    }) => {
      return [/*#__PURE__*/_react.default.createElement(_sortableTableHeader.default, {
        key: "entryStatus",
        columnID: "entryStatus",
        sortedColumnID: sortedColumnID,
        sortedDirection: sortedDirection,
        onClick: onToggleSort
      }, "Status"), _ref];
    });
    _defineProperty(this, "_renderExtraColumns", entry => {
      return [/*#__PURE__*/_react.default.createElement("td", {
        className: "read-only",
        key: "entryStatus"
      }, entry.entryStatusDescription), /*#__PURE__*/_react.default.createElement("td", {
        key: "buttons"
      }, entry.entryStatusRef === 'WAIT' ? /*#__PURE__*/_react.default.createElement(_waitingListManagement.default, {
        entry: entry
      }) : null, /*#__PURE__*/_react.default.createElement(_cancelEntry.default, {
        entry: entry
      }))];
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_entriesTable.default, {
      useFreeCode: this.props.useFreeCode,
      entries: this.props.entries,
      renderExtraColumns: this._renderExtraColumns,
      renderExtraColumnHeadings: this._renderExtraColumnHeadings
    });
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}
_defineProperty(PostalEntriesTable, "partialQueries", {
  Entry: _mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries({
    id: true,
    entryStatusRef: true
  }, _entriesTable.default.partialQueries.Entry), _cancelEntry.default.partialQueries.Entry), _waitingListManagement.default.partialQueries.Entry)
});
var _default = exports.default = PostalEntriesTable;